import React from "react";
import {
    BaseComponentProps,
    createComponentBase,
} from "../../../../libs/components";
import { useOktaUserListQuery } from "../../../../store/okta/userSlice";
import { Dropdown } from "../../../atoms/dropdown";
import { Input } from "../../../atoms/input";
import { useSleetProjectListQuery } from "../../../../store/credentialsManagement/credentialsSlice";

export interface CredentialsManagementRequestProps extends BaseComponentProps {
    payload: any;
    setPayload: any;
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CredentialsManagementRequest = ({
    className,
    payload,
    setPayload,
    setLoading,
}: CredentialsManagementRequestProps) => {
    const componentClassName = "o-credentials-management-request";
    const { Container } = createComponentBase(componentClassName, "div");
    const modifiers = {};
    const { data: users, isLoading: usersLoading } = useOktaUserListQuery({});
    const { data: projects, isLoading: projectLoading } = useSleetProjectListQuery({});
    const [projectOptions, setProjectOptions] = React.useState<any>([]);

    React.useEffect(() => {
        if (projects?.result?.data) {
            if (payload?.subType?.value?.value === "Create Credentials for Sleet") {
                const filteredProjects = projects?.result?.data?.filter((project: any) => {
                    return !project?.credentials?.some((credential: any) => {
                        return credential?.email === payload?.user?.value.value;
                    });
                });
                setProjectOptions(filteredProjects);
            } else {
                const filteredProjects = projects?.result?.data?.filter((project: any) => {
                    return project?.credentials?.some((credential: any) => {
                        return credential?.email === payload?.user?.value.value;
                    });
                });
                setProjectOptions(filteredProjects);
            }
        }
    }, [projects, payload?.user?.value.value, payload?.subType.value]);

    React.useEffect(() => {
        if (setLoading) {
            setLoading(usersLoading || projectLoading);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usersLoading, projectLoading]);

    return (
        <Container className={className} modifiers={modifiers}>
            <div className={`${componentClassName}__form`}>
                <div className={`${componentClassName}__form__items`}>
                    <div className={`${componentClassName}__form__item`}>
                        <label className={`${componentClassName}__form__label`}>User</label>
                        <Dropdown
                            className={`${componentClassName}__form__item__dropdown`}
                            options={users?.result?.data?.map((user: any) => ({
                                label: user?.firstName + " " + user?.lastName,
                                value: user?.email,
                            }))}
                            selected={payload?.user?.value}
                            placeholder="Select a user"
                            onClickChange={(val) =>
                                setPayload({
                                    ...payload,
                                    user: {
                                        value: val,
                                        isError: false,
                                        error: "",
                                    },
                                })
                            }
                            isRequired
                        />
                    </div>

                    <div className={`${componentClassName}__form__item`}>
                        <label className={`${componentClassName}__form__label`}>Projects</label>
                        <Dropdown
                            options={projectOptions.map((project: any) => ({
                                label: project?.name,
                                value: project?.id,
                            }))}
                            placeholder="Please select a project"
                            selected={payload.project?.value as { label: string, value: string }}
                            onClickChange={(e) =>
                                setPayload({
                                    ...payload,
                                    project: {
                                        value: e,
                                        isError: false,
                                        error: "",
                                    },
                                })
                            }
                            isRequired
                        />
                    </div>

                    <Input
                        value={payload?.user?.value.value || ""}
                        label="Email"
                        type="text"
                        placeholder="Enter email address"
                        className={`${componentClassName}__form__item__input`}
                        onChange={() => { }}
                        readonly
                        isRequired
                        isStar
                    />
                </div>
            </div>
        </Container>
    );
};
